export const appConfig = {
  // Available clients from environment variable (comma-separated)
  availableClients: process.env.REACT_APP_AVAILABLE_CLIENTS?.split(',').map(client => client.trim()) || [
    'indmoney',
    'spinny_b2c_prod', 
    'cars24_prod',
    'payu_prod',
    'autorox',
    'attestr',
    'sk_finance_prod',
    'ice_vehicle_prod_user'
  ],
  
  // Default font from environment
  defaultFont: process.env.REACT_APP_DEFAULT_FONT || 'JetBrains Mono',
  
  // Dashboard title from environment
  dashboardTitle: process.env.REACT_APP_DASHBOARD_TITLE || '📊 Enhanced EN Gateway Dashboard',
  
  // CORS test feature flag
  enableCorsTest: process.env.REACT_APP_ENABLE_CORS_TEST === 'true',
  
  // Authentication configuration
  auth: {
    enabled: process.env.REACT_APP_AUTH_ENABLED === 'true',
    usernames: process.env.REACT_APP_AUTH_USERNAMES?.split(',').map(user => user.trim()) || ['admin'],
    passwords: process.env.REACT_APP_AUTH_PASSWORDS?.split(',').map(pass => pass.trim()) || ['admin123']
  }
}; 